// extracted by mini-css-extract-plugin
export default {"container":"style_container__Ti2wX","headerWrapper":"style_headerWrapper__Y9dVq","content":"style_content__RoV39","loadingWrapper":"style_loadingWrapper__8Na2N"};